export default __webpack_public_path__ + "static/media/line-design.44a1778a.svg";